import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@assetaccountant/core';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';
import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';
import { IntegrationsService } from '@assetaccountant/integrations/services/integrations.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-quickbooks-disconnect-realm',
  templateUrl: './quickbooks-disconnect-realm.component.html',
  styleUrls: ['./quickbooks-disconnect-realm.component.scss'],
  standalone: false,
})
export class QuickBooksDisconnectRealmComponent implements OnInit {
  get title() {
    return { pageTitle: 'Disconnecting QuickBooks...' };
  }

  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<
      {},
      {},
      { provider: string; realmId: string; isRelog?: boolean }
    >,
    private router: Router,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private integrationService: IntegrationsService,
  ) {}

  async ngOnInit() {
    const returnUrl = new URL(location.href);

    if (!returnUrl.searchParams.has('isRelog')) {
      returnUrl.searchParams.append('isRelog', 'true');
    }

    // If the user is not authenticated, we need to authenticate them with the external identity provider.
    if (!this.authService.isAuthenticated()) {
      this.authService.init(returnUrl.toString(), { acr_values: 'idp:Intuit' });
      return;
    }

    // Ensure the user is authenticated with the correct identity provider.
    if (!this.route.snapshot.queryParams.isRelog) {
      this.authService.logOut(returnUrl.toString());
      return;
    }

    if (this.route.snapshot.queryParams.realmId) {
      this.integrationService
        .disconnectIntegrationTenant(
          IntegrationType.QuickBooks,
          this.route.snapshot.queryParams.realmId,
        )
        .subscribe(disconnectResponse => {
          if (disconnectResponse.disconnectedRegisters.length > 0) {
            this.toastr.success(
              `${disconnectResponse.disconnectedRegisters.length} registers that were connected to QuickBooks company "${disconnectResponse.companyName}" have now been disconnected.`,
            );
          } else {
            this.toastr.info('No registers found connected to the specified QuickBooks company.');
          }
          this.router.navigate(['/organisations/-'], { queryParams: {} });
        });
    } else {
      this.toastr.info('No realmId provided, no registers were disconnected.');
      await this.router.navigate(['/organisations/-']);
    }
  }
}
